import ReportEditConfigController from '../ATReportEditConfigController'
import ThreeLevelReportGroupingSelector from '../../ThreeLevelReportGroupingSelector'
import $ from 'jquery'
import {Feature, isEnabled} from '../../../features'
import {ReportColumnsFormatCostOfWork} from 'constants'
import {ReportGroupingLevel} from '../../constants'
import ReportColumnsSelectorButtonsCostOfWork from '../../../controls/ReportColumnsSelectorButtonsCostOfWork'
import SimpleTooltip from '../../../SimpleTooltip'
import messageResource from '../../../messageResource'
import CustomCheckbox from '../../../components/customCheckbox/CustomCheckbox'

export default class CostReportEditConfigController extends ReportEditConfigController {}

CostReportEditConfigController.prototype.init = function ( config )
{
    ReportEditConfigController.prototype.init.call(this, config);

    const self = this;
    this.reportAuthorizationInfo = config.reportAuthorizationInfo
    const reportParameters = this.makeReportParamsAccordingToFeatures(config.reportParameters);
    this.configChangedCallback = config.changeCallback;
    const configChanged = function () { self.configChanged(); };

    this.timeFormatSelector = this.initTimeFormatSelector(reportParameters.timeFormat, configChanged);
    const groupingLevelsSelection = [reportParameters.firstGroupingLevel, reportParameters.secondGroupingLevel, reportParameters.thirdGroupingLevel];
    this.groupingSelector = new ThreeLevelReportGroupingSelector().init( {
                                                                             selectorId: "reportGroupingSelector",
                                                                             enableNoneFirstGrouping: false,
                                                                             enableGroupByBillingType: isEnabled(Feature.BTY) || this.checkGroupingLevel(ReportGroupingLevel.BILLING_TYPE, groupingLevelsSelection),
                                                                             enableGroupByUsers: false,
                                                                             enableGroupByUserGroups: false,
                                                                             includeTTCommentsInDetailsLevel: false,
                                                                             groupingLevelsSelection: groupingLevelsSelection,
                                                                             changesCallback: function() { self.removeGroupingLevelsSelectionError(); configChanged(); }
                                                                         });

    const isShowUGR =  isEnabled(Feature.UGR) || reportParameters.columnsConfig !== ReportColumnsFormatCostOfWork.USERS_ONLY;
    if (isShowUGR)
        this.columnsFormatSelector = this.initListSelector("columnsDisplayFormat", reportParameters.columnsConfig, configChanged);

    this.columnsFormat = new ReportColumnsSelectorButtonsCostOfWork().init({containerId :"columnsFormatCheckboxesTable",
                                                                               selector: self.columnsFormatSelector,
                                                                               columnsFormat:  reportParameters.columnsConfig,
                                                                               showSpentTime: reportParameters.showSpentTime,
                                                                               showAverageRates: reportParameters.showAverageRates,
                                                                               showUserRates: reportParameters.showUserRates,
                                                                               showSubtotalsByDepartments: reportParameters.showSubtotalsByDepartments,
                                                                               changeCallback: configChanged});
    
    this.cpSelector = this.makeCPSelector(reportParameters.customersProjectsSelection);
    this.userSelector = this.makeUserSelector({
        ...config,
        allUsersAvailable: config.reportAuthorizationInfo.allUsersAvailable
    })
    
    if( isEnabled(Feature.LVT) || reportParameters.showLeaveTimeCosts )
    {
        $("#leaveTimeCosts").show();
        $("#generalCostsConfigSection").show();
        this.showLeaveTimeCostsChexbox = $( "#showLeaves" );
        this.showLeaveTimeCostsChexbox.prop("checked", reportParameters.showLeaveTimeCosts);
        this.showLeaveTimeCostsChexbox.on("change", configChanged);
    }

    if( isEnabled(Feature.OVR) || reportParameters.showOvertimeAddition )
    {
        $("#overtimeAddition").show();
        $("#generalCostsConfigSection").show();
        this.showOvertimeChexbox = $("#showOvertime");
        this.showOvertimeChexbox.prop("checked", reportParameters.showOvertimeAddition);
        this.showOvertimeChexbox.on("change", configChanged);
    }

    this.makeShowOtherUsersCheckbox(reportParameters.includeOtherUsersColumn, configChanged)

    return this;
};

CostReportEditConfigController.prototype.makeShowOtherUsersCheckbox = function (includeOtherUsersColumn, onChangeCallback) {
    const $checkboxContainer = $(".showOtherUsersCheckboxRow")
    $checkboxContainer.toggle(!this.reportAuthorizationInfo.allUsersAvailable)

    if (!this.reportAuthorizationInfo.allUsersAvailable) {
        const labelText = this.reportAuthorizationInfo.anyOtherUsersAvailable ?
                          messageResource.getMessage('report.common.include_not_assigned_users') :
                          messageResource.getMessage('report.common.include_other_users')
        this.showOtherUsersCheckbox = new CustomCheckbox({
            label: labelText,
            checkboxAdditionalClass: 'checkboxInput',
            checkmarkAdditionalClass: 'hiddenCheckmark',
            onChange: () => onChangeCallback()
        }).init($checkboxContainer)

        this.showOtherUsersCheckbox.setState({
            checked: includeOtherUsersColumn
        })

        this.showOtherUsersCheckboxTooltip = new SimpleTooltip({
            text: messageResource.getMessage('report.common.show_other_users_checkbox_tooltip_text'),
        }).init($('body'))
        this.showOtherUsersCheckboxTooltip.subscribeToMouseEvents(this.showOtherUsersCheckbox.getEl())

        this._updateIncludeOtherUsersCheckbox()
    }
};

CostReportEditConfigController.prototype._updateIncludeOtherUsersCheckbox = function() {
    if (this.showOtherUsersCheckbox) {
        const disabled = this.userSelector && this.userSelector.getSelection().allUsers !== true
        this.showOtherUsersCheckbox.setState({
            checked: !disabled && this.showOtherUsersCheckbox.isChecked(),
            disabled
        })

        this.showOtherUsersCheckboxTooltip.setEnabled(disabled)
    }
}

CostReportEditConfigController.prototype.updateUI = function (blinkError) {
    ReportEditConfigController.prototype.updateUI.call(this, blinkError)
    this._updateIncludeOtherUsersCheckbox()
};

CostReportEditConfigController.prototype.getConfig = function () {
    const reportColumnsResult = this.columnsFormat.getSelection();
    const groupingLevelValues = this.groupingSelector.getValues();
    return {
        timeFormat: this.timeFormatSelector.getValue(),
        userSelection: this.userSelector.getSelection(),
        showLeaveTimeCosts: !!this.showLeaveTimeCostsChexbox && this.showLeaveTimeCostsChexbox.is(":checked"),
        showOvertimeAddition: !!this.showOvertimeChexbox && this.showOvertimeChexbox.is(":checked"),
        columnsConfig:reportColumnsResult.columnsConfig,
        showSpentTime : reportColumnsResult.showSpentTime,
        showAverageRates : reportColumnsResult.showAverageRates,
        showUserRates : reportColumnsResult.showUserRates,
        showSubtotalsByDepartments: reportColumnsResult.showSubtotalsByDepartments,
        customersProjectsSelection: this.cpSelector.getCpSelection(),
        firstGroupingLevel: groupingLevelValues[0],
        secondGroupingLevel: groupingLevelValues[1],
        thirdGroupingLevel: groupingLevelValues[2],
        includeOtherUsersColumn: !!this.showOtherUsersCheckbox && this.showOtherUsersCheckbox.isChecked()
    };
};

CostReportEditConfigController.prototype.resetConfig = function () {
    this.timeFormatSelector.setActiveItemByValue(this.initReportParameters.timeFormat, true);
    this.userSelector.setSelection(this.initReportParameters.userSelection);
    if(this.showLeaveTimeCostsChexbox)
        this.showLeaveTimeCostsChexbox.prop("checked", this.initReportParameters.showLeaveTimeCosts);
    if(this.showOvertimeChexbox)
        this.showOvertimeChexbox.prop("checked", this.initReportParameters.showOvertimeAddition);
    this.cpSelector.setSelection(this.initReportParameters.customersProjectsSelection);
    this.columnsFormat.setValue(this.initReportParameters.columnsConfig,
                                this.initReportParameters.showSpentTime,
                                this.initReportParameters.showAverageRates,
                                this.initReportParameters.showUserRates,
                                this.initReportParameters.showSubtotalsByDepartments);
    this.groupingSelector.setValues([this.initReportParameters.firstGroupingLevel, this.initReportParameters.secondGroupingLevel, this.initReportParameters.thirdGroupingLevel]);
};

CostReportEditConfigController.prototype.validate = function()
{
    this.errors = [];

    if (!this.userSelector.validateIsUserSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_USER_SELECTION );

    if (!this.cpSelector.checkSelected())
        this.errors.push( this.possibleErrors.ERROR_EMPTY_CP_SELECTION );

    if (!this.groupingSelector.validate())
        this.errors.push(this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR);

    return this.errors.length === 0;
};

CostReportEditConfigController.prototype.initErrorsToSectionElsMap = function()
{
    const errorsToSectionElsMap = {};
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_USER_SELECTION] = this.panelEl.find( "#userSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_EMPTY_CP_SELECTION] = this.panelEl.find( "#cpSelectorId" );
    errorsToSectionElsMap[this.possibleErrors.ERROR_IN_GROUPING_LEVELS_SELECTOR] = this.panelEl.find( ".reportGroupingSelectorContainer" );
    return errorsToSectionElsMap;
};

CostReportEditConfigController.prototype.setSelectorsInitStateFromCurrent = function () {
    ReportEditConfigController.prototype.setSelectorsInitStateFromCurrent.call(this);

    if(this.userSelector){
        this.userSelector.setInitialValueFromCurrent();
    }
    if(this.cpSelector) {
        this.cpSelector.setInitialValueFromCurrent();
    }
};

CostReportEditConfigController.prototype.makeReportParamsAccordingToFeatures = function ( reportParameters ) {
    return reportParameters;
};


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/costOfWork/CostReportEditConfigController.js